import React from 'react'
import { Redirect, Router } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import Main from '../views/main/main'
import MainPrivilege from '../views/main-privilege'
import { AuthRouter } from './base-router'
import { history } from './histroy'

export default () => {
    return (
        <Router history={history}>
            <Switch>
                <AuthRouter path={'/main'} component={Main}></AuthRouter>
                <Route path={'/privilege'} component={MainPrivilege}></Route>
                <Redirect to={'/main'}></Redirect>
            </Switch>
        </Router>
    )
}
